// /rights — роли и права. Право — rights.read. Поиск по операции и скрытые колонки ролей
// «Матрицы прав» — в адресе страницы (?q=&hide=controller,observer; T160).
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { RightsPage } from '../../../features/rights/RightsPage.tsx';
import { parseRightsSearch } from '../../../features/rights/search.ts';
import type { RightsSearch } from '../../../features/rights/search.ts';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/rights')({
  validateSearch: parseRightsSearch,
  beforeLoad: requireSection('rights'),
  staticData: { crumb: 'Роли и права' },
  component: RightsRoute,
});

function RightsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: RightsSearch) => void navigate({ to: '/rights', search: next, replace: true }),
    [navigate],
  );
  return <RightsPage search={search} onSearchChange={onSearchChange} />;
}
